/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function(){
  $('.product_meta_content').on('click', '.tab_link', function(){
    $(this).toggleClass('active').next().slideToggle();
    $('.tab_content').$(this).next().slideup(300);
    $(this).sliblings().removeClass("active");
  })


  $('.header__mobile-nav-toggle').click(function(){
    $('.cstm_icon_list').toggleClass('cst_hide_bar');
  });

});

/**
 * Accessibility fix: the "Easy Overlay" app swaps product images client-side after
 * the page loads, in several different places (product grid cards via the
 * "easyOverlayImage" class, and the main product gallery/zoom carousel with no
 * special class, identifiable only by its image src). None of the images it
 * injects have alt text. This watches for that swap and backfills the alt text
 * from the best available product title on the page.
 */
(function () {
  function isEasyOverlayImage(imgEl) {
    if (!imgEl || imgEl.tagName !== 'IMG') return false;
    if (imgEl.closest('.easyOverlayImage')) return true;
    var src = imgEl.getAttribute('src') || '';
    return src.indexOf('easy-overlay') !== -1;
  }

  function pageProductTitle() {
    var h1 = document.querySelector('h1');
    var text = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    if (text) return text;
    var titleText = (document.title || '').split(/[-–|]/)[0].trim();
    return titleText || 'Product image';
  }

  function productTitleFor(imgEl) {
    var productItem = imgEl.closest('.product-item');
    var titleEl = productItem ? productItem.querySelector('.product-item__title') : null;
    var text = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    return text || pageProductTitle();
  }

  function fixAlt(imgEl) {
    if (!isEasyOverlayImage(imgEl)) return;
    if ((imgEl.getAttribute('alt') || '').trim() !== '') return;
    imgEl.setAttribute('alt', productTitleFor(imgEl));
  }

  function fixAllWithin(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('img').forEach(fixAlt);
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixAllWithin(document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') {
            fixAlt(node);
          }
          fixAllWithin(node);
        });
      } else if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
        fixAlt(mutation.target);
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src']
  });
})();

/**
 * Accessibility fix: the Flickity carousel library (used for horizontal product
 * scrollers) marks off-screen slides aria-hidden="true" but leaves their links and
 * buttons focusable, so keyboard users can tab into cards screen readers are told
 * don't exist. This keeps tabindex in sync with aria-hidden, scoped to carousels
 * only so it doesn't interfere with modals/drawers that already manage focus.
 */
(function () {
  var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';
  var ORIGINAL_TABINDEX_ATTR = 'data-a11y-original-tabindex';

  function setInert(container) {
    container.querySelectorAll(FOCUSABLE_SELECTOR).forEach(function (el) {
      if (!el.hasAttribute(ORIGINAL_TABINDEX_ATTR)) {
        el.setAttribute(ORIGINAL_TABINDEX_ATTR, el.getAttribute('tabindex') || '');
      }
      el.setAttribute('tabindex', '-1');
    });
  }

  function clearInert(container) {
    container.querySelectorAll('[' + ORIGINAL_TABINDEX_ATTR + ']').forEach(function (el) {
      var original = el.getAttribute(ORIGINAL_TABINDEX_ATTR);
      if (original) {
        el.setAttribute('tabindex', original);
      } else {
        el.removeAttribute('tabindex');
      }
      el.removeAttribute(ORIGINAL_TABINDEX_ATTR);
    });
  }

  function syncCarouselSlide(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      setInert(el);
    } else {
      clearInert(el);
    }
  }

  function scanExisting(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.flickity-slider [aria-hidden="true"]').forEach(syncCarouselSlide);
    if (root.matches && root.matches('.flickity-slider [aria-hidden="true"]')) {
      syncCarouselSlide(root);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    scanExisting(document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        if (mutation.target.closest && mutation.target.closest('.flickity-slider')) {
          syncCarouselSlide(mutation.target);
        }
      } else if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          scanExisting(node);
        });
      }
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
})();
